var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVoucherAvailable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 58.2295,
    height: 62.5966,
    viewBox: "0 0 58.2295 62.5966",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 27080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6147 5.47372C27.0181 3.50876 31.2113 3.50876 34.6147 5.47372L48.7295 13.6229C52.1329 15.5878 54.2295 19.2192 54.2295 23.1491V39.4474C54.2295 43.3774 52.1329 47.0088 48.7295 48.9737L34.6147 57.1229C31.2113 59.0878 27.0181 59.0878 23.6147 57.1229L9.5 48.9737C6.09659 47.0088 4 43.3774 4 39.4474V23.1491C4 19.2192 6.09659 15.5878 9.5 13.6229L23.6147 5.47372Z",
    fill: "url(#paint0_linear_0_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6147 3.74165C26.6369 1.41943 31.5925 1.41943 35.6147 3.74165L49.729 11.8911C53.7511 14.2132 56.2289 18.5045 56.229 23.1489V39.4477C56.2289 44.0921 53.7511 48.3833 49.729 50.7055L35.6147 58.8549C31.5925 61.1772 26.6369 61.1772 22.6147 58.8549L8.50048 50.7055C4.47834 48.3833 2.00057 44.0921 2.00048 39.4477V23.1489C2.00057 18.5045 4.47834 14.2132 8.50048 11.8911L22.6147 3.74165Z",
    stroke: "url(#paint1_linear_0_59)",
    strokeOpacity: 0.3,
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "award",
    clipPath: "url(#clip0_0_59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1147 20.8816C25.663 20.8816 22.8647 23.6798 22.8647 27.1316C22.8647 30.5834 25.663 33.3816 29.1147 33.3816C32.5665 33.3816 35.3647 30.5834 35.3647 27.1316C35.3647 23.6798 32.5665 20.8816 29.1147 20.8816ZM20.7814 27.1316C20.7814 22.5293 24.5124 18.7983 29.1147 18.7983C33.7171 18.7983 37.4481 22.5293 37.4481 27.1316C37.4481 31.734 33.7171 35.465 29.1147 35.465C24.5124 35.465 20.7814 31.734 20.7814 27.1316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9256 32.224C33.4959 32.1483 34.0196 32.5493 34.0953 33.1196L35.3557 42.6196C35.4083 43.0161 35.2292 43.4077 34.8949 43.6273C34.5606 43.8469 34.1301 43.8556 33.7871 43.6499L29.1147 40.8464L24.4423 43.6499C24.0993 43.8556 23.6688 43.8469 23.3345 43.6272C23.0002 43.4076 22.8211 43.016 22.8738 42.6195L24.1342 33.1299C24.21 32.5596 24.7337 32.1587 25.304 32.2344C25.8743 32.3102 26.2752 32.8339 26.1994 33.4042L25.2235 40.7516L28.5788 38.7384C28.9087 38.5405 29.3208 38.5405 29.6507 38.7384L33.0063 40.7518L32.03 33.3936C31.9544 32.8233 32.3554 32.2997 32.9256 32.224Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_59",
    x1: 2.18321,
    y1: 24.1333,
    x2: 56.4605,
    y2: 24.1233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#863AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5936E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_59",
    x1: 2.18321,
    y1: 24.1333,
    x2: 56.4605,
    y2: 24.1233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#863AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5936E4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_59"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(16.6147 18.7983)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucherAvailable);
export default __webpack_public_path__ + "static/media/voucher-available.dddadac840f78e8d917e49b1edecf0a5.svg";
export { ForwardRef as ReactComponent };